import { TweenMax, TimelineMax } from 'gsap';
import { useState, useEffect } from 'react';
import TextA from '../textA';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/');

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [isEnterA, setIsEnterA] = useState(false);

    const imgLocale = getImageLocal(locale, ['au', 'cn', 'za']);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitL', //触发元素
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 236, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setIsEnterA(true);
        });

        const tweenA1 = TweenMax.to('.kitL .textA', 0.4, {
            y: -300,
            ease: 'none',
        });
        sceneA1.setTween(tweenA1);

        AniContainer.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitL', //触发元素
            offset: 240, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnterA(false);
        });

        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.to('.kitL .kit-img-a1', 0.4, {
            opacity: 0,
            ease: 'none',
        });
        const tweenC1 = TweenMax.to('.kitL .kit-img-box2', 0.4, {
            opacity: 0,
            ease: 'none',
        });
        const tweenA2 = TweenMax.to('.kitL .kit-img-box1', 0.4, {
            scale: 1,
            x: 0,
            y: 0,
            ease: 'none',
        });
        const tweenA3 = TweenMax.to('.kitL .msg-box-a', 0.4, {
            opacity: 1,
            ease: 'none',
        });
        const tweenA4 = TweenMax.to('.kitL .kit-img1', 0.4, {
            y: -1000,
            ease: 'none',
        });
        const tweenA5 = TweenMax.to('.kitL .msg-box-a', 0.4, {
            opacity: 0,
            y: -100,
            ease: 'none',
        });
        const tweenB1 = TweenMax.to('.kitL .img-box-a', 0.4, {
            y: 0,
            ease: 'none',
        });
        const tweenA6 = TweenMax.to('.kitL .kit-ms-tips', 0.4, {
            opacity: 1,
            ease: 'none',
        });
        const tweenA7 = TweenMax.to('.kitL .kit-inter-out2 .kit-inter', 0.4, {
            opacity: 1,
            ease: 'none',
        });
        timelineA1.add(tweenA1).add(tweenC1, 0).add(tweenA2).add(tweenA3).add(tweenA5, 1.2).add(tweenB1, 1.2).add(tweenA4).add(tweenA6).add(tweenA7);
        sceneA1.setTween(timelineA1);

        AniContainer.addScene(sceneA1);
    }, []);

    const openAllWin = () => {
        callBack('modal-power-hub');
    };

    return (
        <div className={`${css.kitL} kitL ${isEnterA ? 'isEnterA' : ''}`}>
            <div className="ef-scroll-ani-total-box">
                <div className="ef-scroll-ani">
                    <div className="img-box-a-out">
                        <div className="textA-out">
                            <TextA />
                        </div>
                        <div className="img-box-a">
                            <div className="kit-img-a1 kit-img-a1-t1">
                                <div className="kit-img-a1-in">
                                    <div className="kit-img-a1-in-a kit-img-a1-in-a-1">
                                        <EFPic name={['kitL3.webp', 'kitL3.jpg']} className="fullImgs" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="kit-img-a1 kit-img-a1-t2">
                                <div className="kit-img-a1-in">
                                    <div className="kit-img-a1-in-a kit-img-a1-in-a-2">
                                        <EFPic name={['kitL4.webp', 'kitL4.png']} className="fullImgs" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="kit-img-box kit-img-box1">
                                <div className="msg-box-a">
                                    <div className="kit-inter">
                                        <div className="kit-ms2">{t('presale.product.kitL_ms2')}</div>
                                        <div className="kit-ms3">{t('presale.product.kitL_ms3')}</div>
                                        <div className="kit-ms4">{t('presale.product.kitL_ms4')}</div>
                                    </div>
                                </div>

                                <div className="kit-img2">
                                    <div className="kit-img2-in">
                                        <EFPic name={[`kitL1_${imgLocale}.webp`, `kitL1_${imgLocale}.png`]} className="fullImgs" alt="" />
                                        <span className="kit-ms-tips kit-ms-tipsa kit-ms-tipsa1">{t('presale.product.kitL_ms_tipsa1')}</span>
                                        <span className="kit-ms-tips kit-ms-tipsa kit-ms-tipsa2">{t('presale.product.kitL_ms_tipsa2')}</span>
                                        <span className="kit-ms-tips kit-ms-tipsb kit-ms-tipsb3">{t('presale.product.kitL_ms_tipsa3')}</span>
                                        <span className="kit-ms-tips kit-ms-tipsb kit-ms-tipsb4">{t('presale.product.kitL_ms_tipsa4')}</span>
                                    </div>
                                </div>
                                <div className="kit-img1">
                                    <EFPic name={['kitL2.webp', 'kitL2.png']} className="fullImgs" alt="" />
                                </div>
                            </div>
                            <div className="kit-img-box kit-img-box2">
                                <div className="kit-img1">
                                    <EFPic name={['kitL2.webp', 'kitL2.png']} className="fullImgs" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="kit-inter-out2">
                            <div className="kit-inter">
                                <div className="kit-ms5">
                                    <span className="color-ms1">{t('presale.product.kitL_ms5_1')}</span>
                                    {t('presale.product.kitL_ms5_2')}
                                </div>
                                <div className="more-win-fun more-win-fun2" onClick={openAllWin}>
                                    {t('presale.product.kitL_more_win_fun')}
                                    <span className="more-win-fun-icon">
                                        <EFProductWinAdd />
                                    </span>
                                </div>
                            </div>
                            <div className="product-white-border-bg2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
